'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsListCustom = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _OptionCustom = require('../OptionCustom/OptionCustom');

var _OptionPropTypeCustom = require('../OptionPropType/OptionPropTypeCustom');

var _OptionsListStyled = require('./styles/OptionsListStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  options: _propTypes2.default.arrayOf(_OptionPropTypeCustom.OptionPropTypeCustom),
  selectedItem: _OptionPropTypeCustom.OptionPropTypeCustom,
  onChange: _propTypes2.default.func,
  createListRef: _propTypes2.default.func,
  maxLines: _propTypes2.default.number
};
var defaultProps = {
  fullWidth: false,
  dense: false,
  options: [],
  selectedItem: {},
  onChange: _reactackleCore.noop,
  createListRef: _reactackleCore.noop,
  maxLines: 5.5
};

var OptionsListCustom = exports.OptionsListCustom = function (_Component) {
  _inherits(OptionsListCustom, _Component);

  function OptionsListCustom(props) {
    _classCallCheck(this, OptionsListCustom);

    var _this = _possibleConstructorReturn(this, (OptionsListCustom.__proto__ || Object.getPrototypeOf(OptionsListCustom)).call(this, props));

    _this._handleOptionClick = _this._handleOptionClick.bind(_this);
    return _this;
  }

  _createClass(OptionsListCustom, [{
    key: '_handleOptionClick',
    value: function _handleOptionClick(index) {
      this.select(this.props.options[index]);
    }
  }, {
    key: 'select',
    value: function select(item) {
      this.props.onChange({
        value: item
      });
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      var _this2 = this;

      return this.props.options.map(function (item, index) {
        return _react2.default.createElement(_OptionCustom.OptionCustom, {
          key: (0, _reactackleCore.getKey)(item, index),
          text: item.text,
          selected: item === _this2.props.selectedItem,
          disabled: item.disabled,
          item: item,
          index: index,
          dense: _this2.props.dense,
          fullWidth: _this2.props.fullWidth,
          onClick: _this2._handleOptionClick
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this._renderOptions();

      return _react2.default.createElement(_OptionsListStyled.OptionsListStyled, {
        innerRef: this.props.createListRef,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        maxLines: this.props.maxLines
      }, options);
    }
  }]);

  return OptionsListCustom;
}(_react.Component);

OptionsListCustom.propTypes = propTypes;
OptionsListCustom.defaultProps = defaultProps;
OptionsListCustom.displayName = 'OptionsListCustom';